export const BASE_API_URL = "https://ws.bullseyelocations-staging.com";
export const CLIENT_ID = 7205;
export const API_KEY = "636932b6-09b2-41fb-af64-701c9d758821-zxyab";
